<template>
  <div id="app" :class="isExpandNav?'appOverflowHide':'appOverflowShow'">
    <Header></Header>
    <div id="main-content" :class="isExpandNav?'marginLeft1':'marginLeft2'">
      <router-view/>
    </div>
    <Footer :class="isExpandNav?'marginLeft1':'marginLeft2'"></Footer>
  </div>
</template>

<script>
import Header from './layout/header.vue'
import Footer from './layout/footer.vue'
import {
  mapState,
  mapMutations
} from 'vuex'
export default {
  components: {
    Header,
    Footer
  },
  data () {
    return {

    }
  },
  methods: {
    ...mapMutations(['expandNav']),
    resize () {
      let w = document.body.clientWidth ||
        document.documentElement.clientWidth ||
        window.innerWidth
      if (w > 780) {
        document.querySelector('html').style.fontSize = (100 / 1920) * w + 'px'
      } else {
        document.querySelector('html').style.fontSize = (100 / 750) * w + 'px'
      }
    }
  },
  mounted () {
    document.body.onresize = this.resize
    this.resize()
  },
  computed: {
    ...mapState(['isExpandNav'])
  }
}
</script>

<style lang="less" scoped>
  @media screen and (min-width: 769px) {
    #main-content{
      /*padding-left: 2.48rem;*/
      /*padding-right: 2.48rem;*/
    }
  }
  @media screen and (max-width: 769px) {
    #app{
      position: relative;
    }
    .appOverflowShow{
      overflow: auto;
    }
    .appOverflowHide{
      overflow: hidden;
    }
    #main-content{
      padding-left: 0!important;
      padding-right: 0!important;
      width: 7.5rem;
    }
    .marginLeft1{
      transition: margin-left 0.3s linear;
      margin-left: 5rem;
    }
    .marginLeft2{
      transition: margin-left 0.3s linear;
      margin-left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue